import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivate } from '@angular/router';
import { AuthenticationService, DialogService } from '@services/index';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

export const canDeactivateState = {
  defendAgainstBrowserBackButton: false,
};

const options = {
  title: 'You have unsaved changes...',
  message: 'What would you like to do?',
  cancelText: 'Stay on this page',
  confirmText: 'Leave without saving',
};

@Injectable()
export class PendingChangesGuard
  implements CanDeactivate<ComponentCanDeactivate>
{
  constructor(
    readonly matDialog: MatDialog,
    private dialogService: DialogService,
    private authService: AuthenticationService
  ) {}
  canDeactivate(
    component: ComponentCanDeactivate
  ): boolean | Observable<boolean> {
    return (
      this.authService.forceLogout ||
      component.canDeactivate() ||
      this.promptUserAboutUnsavedChanged()
    );
  }

  private promptUserAboutUnsavedChanged(): boolean | Observable<boolean> {
    return this.dialogService
      .openConfirm(options)
      .afterClosed()
      .pipe(
        tap((confirmed) => {
          if (!confirmed && canDeactivateState.defendAgainstBrowserBackButton) {
            history.pushState(null, '', '');
          }
        })
      );
  }
}
